import * as React from "react";
import {
  IWorkingHours,
  MeetingOrWorkingHours,
  WeekSettingContainer,
  CopyButtonStyle,
  Day,
} from "@ui/working-hours";

export interface SplitWorkingHoursProps {
  workingHours: IWorkingHours;
  copyButtonStyle: CopyButtonStyle | null;
  onUpdateWorkingHours: (workingHours: IWorkingHours, updatedDayOfWeek: Day) => void;
}

export const SplitWorkingHours = (props: SplitWorkingHoursProps) => {
  return (
    <WeekSettingContainer {...props} isMeetingOrWorkingHours={MeetingOrWorkingHours.WorkingHours} />
  );
};
